export const FieldsetDataHooks = {
    Error: 'fieldset-error',
    Label: 'fieldset-label',
    LabelAsterisk: 'fieldset-label-asterisk',
};
//# sourceMappingURL=types.js.map